// src/helpers/i18n.js

import { translations } from 'src/translations.js'; // Import translations

export let currentLanguage = localStorage.getItem('lang') || 'en'; // Retrieve the stored language or default to 'en'

export function setLanguage(lang) {
  currentLanguage = lang; // Update the global language
  localStorage.setItem('lang', lang); // Store the selected language in local storage
}

export function translate(key) {
  return translations[currentLanguage][key] || key; // Return the translation or fallback to the key itself
}
